import React, { useState } from 'react';
import { func, string } from 'prop-types';

import { referenceType } from 'types/officeTypes';

import ContactInformation from './layout';

const ContactInformationContainer = ({ documentType, onChange, reference, value }) => {
  const [disabled, setDisabled] = useState(false);

  const disableForm = () => setDisabled(true);
  const enableForm = () => setDisabled(false);

  const onSubmit = values => {
    onChange(values);
    disableForm();
  };

  return (
    <ContactInformation
      disabled={disabled}
      disableForm={disableForm}
      documentType={documentType}
      enableForm={enableForm}
      hasInitialValues={!!value}
      initialValues={value}
      onSubmit={onSubmit}
      reference={reference}
    />
  );
};

ContactInformationContainer.propTypes = {
  documentType: string,
  onChange: func,
  reference: referenceType,
  value: string
};

export default ContactInformationContainer;
